const Service = () => {
  const serviceList = [
    {
      img: "/images/service1.png",
      name: "누수 관련 서비스 제공",
      txt2: "아파트, 빌라, 주택과 같은 건물 및",
      txt3: "그 밖에 다양한 누수현장들을 해결합니다",
      // link: "https://blog.naver.com/PostList.naver?blogId=rna0186&from=postList&categoryNo=24",
    },
    {
      img: "/images/service2.png",
      name: "고압세척 관련 서비스 제공",
      txt2: "하수구, 배관, 배수구 등 막히거나",
      txt3: "기타 고압세척이 필요한 현장을 해결합니다",
      // link: "https://blog.naver.com/PostList.naver?blogId=rna0186&from=postList&categoryNo=25",
    },
  ];

  return (
    <div
      id="service"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto py-14 lg:py-28 xl:py-36"
    >
      <div
        id="title"
        className="relative w-full h-fit text-center mb-10 xl:mb-20 text-black"
      >
        <div className="relative w-fit h-fit mx-auto">
          <img
            src="/images/logo.png"
            alt="장인배관 로고"
            width={247}
            height={58}
            className="!relative w-full h-auto max-w-32"
          />
        </div>
        <h2 className="font-light my-3">장인배관의 서비스&nbsp;목록</h2>
        <p className="lg:text-xl ">
          다양한&nbsp;상황의&nbsp;누수&nbsp;·&nbsp;고압세척&nbsp;서비스를
          받아보실&nbsp;수&nbsp;있습니다
        </p>
      </div>
      <div className="relative w-full h-fit max-w-screen-lg mx-auto grid grid-cols-1 md:grid-cols-2 gap-5 lg:gap-6">
        {serviceList.map((v, i) => (
          <div key={i} data-aos="fade-up" className="relative w-full h-full">
            <div className="relative w-full h-fit p-3 border rounded-3xl btn6 inline-block">
              <div className="relative w-full h-fit rounded-t-2xl overflow-hidden">
                <img
                  className="!relative w-full h-full object-cover object-center transition-transform duration-300 max-h-96"
                  alt={`장인배관 ${v.name}`}
                  src={v.img}
                  width={611}
                  height={589}
                />
              </div>
              <div className=" relative w-full h-fit my-3 2xl:my-5 text-center">
                <p className="gmedium text-2xl 2xl:text-3xl text-primary mb-2">
                  {v.name}
                </p>
                <p className="text-font">{v.txt2}</p>
                <p className="text-font">{v.txt3}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Service;
